import { makeAutoObservable } from "mobx";

export default class UserStore {
  constructor() {
    this._isAuth = true;
    this._user = {};
    makeAutoObservable(this);
  }

  setIsAuth(bool) {
    if (bool === false) localStorage.clear();
    this._isAuth = bool;
  }

  setUser(user) {
    this._user = user;
  }

  getEmail() {
    return this._user.email;
  }

  getId() {
    return this._user.id;
  }

  get isAuth() {
    return this._isAuth;
  }

  get user() {
    return this._user;
  }

  getIsAdmin() {
    return this._user.role === "ADMIN" ? true : false;
  }
}
